import React from 'react';
import { Box, Stack } from '@mui/material';
import { theme } from '../../../../../common/styles/theme';
import { formatElapsed } from '../../shared/components/Tray/CallTimer';
import { PreviewActions } from './PreviewActions';
import { PREVIEW_POSITION_KEY, useDragPosition } from './useDragPosition';

export interface IPreviewStripProps {
	startedAt?: number;
	onBack: () => void;
}

// Replaces the preview tiles while the browser's Picture-in-Picture window shows the participants:
// a thin bar in the same corner, so the lesson page underneath stays visible.
export const PreviewStrip = ({ startedAt, onBack }: IPreviewStripProps) => {
	const [now, setNow] = React.useState(Date.now());
	const drag = useDragPosition(PREVIEW_POSITION_KEY);

	React.useEffect(() => {
		if (!startedAt) return;
		const id = setInterval(() => setNow(Date.now()), 1000);
		return () => clearInterval(id);
	}, [startedAt]);

	return (
		<Stack
			className={'preview preview--strip'}
			ref={drag.ref}
			direction={'row'}
			alignItems={'center'}
			gap={1.5}
			sx={{
				position: 'fixed',
				bottom: theme.spacing(5),
				right: theme.spacing(5),
				zIndex: 1000,
				p: theme.spacing(1, 1.5),
				background: theme.palette.grey[900],
				borderRadius: theme.spacing(.75),
				color: theme.palette.common.white,
				fontSize: theme.typography.subtitle2,
				whiteSpace: 'nowrap',
				cursor: drag.dragging ? 'grabbing' : 'grab',
				touchAction: 'none',
				userSelect: 'none',
				...drag.positionSx,
			}}
			{...drag.handlers}
		>
			<Box
				sx={{
					width: '8px',
					height: '8px',
					borderRadius: '50%',
					background: theme.palette.error.main,
					flexShrink: 0,
				}}
			/>
			<Box sx={{ fontVariantNumeric: 'tabular-nums' }}>
				In call{!!startedAt && ` · ${formatElapsed(now - startedAt)}`}
			</Box>
			<PreviewActions onBack={onBack} />
		</Stack>
	);
};
